import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { ActivatedRouteSnapshot } from '@angular/router';
import { EntityDetailResolver } from 'src/app/core/services/entity-detail.resolver';
import { LiftBoardParameterService } from './lift-board-parameter.service';
import { LiftBoardParameterDetail } from '../models/lift-board-parameter-detail.model';



@Injectable({ providedIn: 'root' })
export class LiftBoardParameterDetailResolver extends EntityDetailResolver<LiftBoardParameterService, LiftBoardParameterDetail> {
  constructor(
    paramService: LiftBoardParameterService
  ) {
    super(paramService);
  }
}
